import {$window} from './Variables';

class ScrollFade {
  constructor(element,options) {
    this.element = element;
    this.options  = options;
  }
  in(callback) {
    const element = this.element,
    options = this.options;

    $window.on('scroll load',function(){
      $(element).each(function(index,element){
        const yFromElement = $(element).offset().top - $window.height();
        if ( ($window.scrollTop() - yFromElement > 0) ) {
          callback(element, options);
        }
      });
    });
  }
}

export default ScrollFade